import { Component, Inject, OnInit, Input } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ReceivedLabSampleService } from "../../../services/received-lab-sample/received-lab-sample.service";
import { ReceivedLabSample } from "../../../model/received-lab-sample/received-lab-sample";
import { NotificationToastService } from "../../../services/notification-toast.service";

@Component({
  selector: "app-received-lab-sample",
  templateUrl: "./received-lab-sample.component.html",
  styleUrls: ["./received-lab-sample.component.css"],
})
export class ReceivedLabSampleComponent implements OnInit {
  loading: boolean;
  updating: boolean;
  items: ReceivedLabSample[] = [];
  showTitle: boolean = true;
  isChangingAll: boolean = false;
  @Input() appointmentId: number;
  @Input() medicalAppointmentProcedureIds: number[] = [];
  @Input() inColumn: boolean;

  get allChecked() {
    return this.items.every((item) => item.Received);
  }

  get someChecked() {
    const checked = this.items.filter((item) => item.Received);
    return checked.length > 0 && checked.length < this.items.length;
  }

  constructor(
    private receivedLabSampleService: ReceivedLabSampleService,
    private notificationToastService: NotificationToastService
  ) {}

  async ngOnInit() {
    try {
      this.loading = true;
      this.showTitle = false;
      if (this.medicalAppointmentProcedureIds.length > 0) {
        this.items =
          await this.receivedLabSampleService.getByMedicalAppointmentProcedureIds(
            this.medicalAppointmentProcedureIds,
            false
          );
      } else if (this.appointmentId) {
        this.showTitle = true;
        this.items = await this.receivedLabSampleService.get(
          this.appointmentId,
          false
        );
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Otros turnos"
      );
    } finally {
      this.loading = false;
    }
  }

  async changeAll(checked: boolean) {
    this.isChangingAll = true;
    this.items.forEach((item) => {
      item.Received = checked;
    });
    this.isChangingAll = false;
    await this.update();
  }

  async update() {
    try {
      if (this.isChangingAll) {
        return;
      }
      this.updating = true;
      await this.receivedLabSampleService.update(this.items);
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Otros turnos"
      );
    } finally {
      this.updating = false;
    }
  }
}
